import {remCalc} from '_themeUtils'

const newsletterModalSmall = {
    NewsletterModalSmall: {
        baseStyle: ({horizontalAlignment, verticalAlignment}) => ({
            wrapper: {
                display: 'none',
                alignItems: verticalAlignment == 'top' ? 'flex-start' : verticalAlignment == 'bottom' ? 'flex-end' : 'center',
                justifyContent: {base: 'center', lg: horizontalAlignment ? horizontalAlignment : 'center'},
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 'modal',
                background: 'color.background.alpha.dark.40',
                p: {base: 'spacing.4', md: 'spacing.6', lg: 'spacing.8'},
            },
            container: {
                maxW: {base: 'unset', md: remCalc(576), lg: remCalc(620)},
                position: 'relative',
                w: '100%',
                maxH: '95%',
                background: 'color.background.white',
                gap: 0,
                padding: {
                    base: `${remCalc(48)} ${remCalc(24)} ${remCalc(24)}`,
                    md: `${remCalc(64)} ${remCalc(24)} ${remCalc(40)}`,
                },
                mb: {
                    base: 'spacing.4',
                    lg: 0,
                },
            },
            input: {
                gap: 'spacing.1',
                '.newsletterInput': {
                    maxW: '100%',
                    gap: {base: remCalc(34), md: 0},
                    pb: {base: 0, md: remCalc(10)},
                },
            },
            inputLabel: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                letterSpacing: remCalc(1),
                textTransform: 'lowercase',
            },
            title: {
                textStyle: {base: 'displayXs', md: 'displayMd'},
                fontWeight: 400,
                mb: 'spacing.5',
            },
            subtitle: {
                fontWeight: 400,
                textStyle: 'paragraphXs',
                mb: 'spacing.5',
                textTransform: 'uppercase',
                letterSpacing: remCalc(2),
                color: 'color.text.black',
            },
            close: {
                position: 'absolute',
                top: 'spacing.6',
                right: 'spacing.6',
            },
            text: {
                textAlign: {base: 'center', md: 'left'},
            },
        }),
    },
}

export default newsletterModalSmall
